<template>
   <Teleport to="body">
      <div class="fixed z-50 flex items-center justify-center w-full h-screen bg-gray-500 bg-opacity-50 pointer-events-none frm-spinner">
         <div class="flex items-center p-5 bg-white rounded-full shadow-md">
            <ion-spinner name="circles"></ion-spinner>
            <div class="px-2 text-sm font-bold text-l animate-pulse">
               Loading<span class="inline-flex ">...</span>
            </div>
         </div>
      </div>
   </Teleport>
</template>

<script setup lang="ts">
   import { IonSpinner } from '@ionic/vue';
</script>